import React, { useState } from 'react';
import { tokens as defaultTokens } from '../tokens';
import MetaLabel from './MetaLabel';

export default function GroundingModal({ tokens = defaultTokens, onClose }) {
  const steps = [
    { n: 5, sense: 'things you can see',   prompt: 'Look around. Name five.' },
    { n: 4, sense: 'things you can touch', prompt: 'Feel them. The fabric, the mug, the rail.' },
    { n: 3, sense: 'things you can hear',  prompt: 'Close your eyes if that helps.' },
    { n: 2, sense: 'things you can smell', prompt: "If you can't smell two, think of two you love." },
    { n: 1, sense: 'thing you can taste',  prompt: 'Take a sip of something. Anything.' },
  ];
  const [step, setStep] = useState(0);
  const done = step >= steps.length;
  const s = !done ? steps[step] : null;

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 100,
      background: tokens.ground + 'f2',
      backdropFilter: 'blur(20px)',
      WebkitBackdropFilter: 'blur(20px)',
      display: 'flex', flexDirection: 'column',
      height: '100dvh',
      overflow: 'hidden',
      animation: `gl-fade 300ms ${tokens.ease}`,
    }}>
      {/* Header */}
      <div style={{
        display: 'flex', justifyContent: 'space-between', alignItems: 'center',
        padding: '16px 20px 0',
        flexShrink: 0,
      }}>
        <MetaLabel tokens={tokens}>Grounding &middot; 5-4-3-2-1</MetaLabel>
        <button className="gl-btn-bare" onClick={onClose} aria-label="Close" style={{
          width: 32, height: 32,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          border: `1px solid ${tokens.edge}`, borderRadius: '50%',
          color: tokens.textMid,
          fontFamily: tokens.fontBody, fontSize: 16, lineHeight: 1,
        }}>&times;</button>
      </div>

      {/* Center section */}
      <div style={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
        {!done ? (
          <div key={step} style={{
            flex: 1, display: 'flex', flexDirection: 'column',
            alignItems: 'center', justifyContent: 'center',
            padding: '0 28px',
            animation: `gl-fade-up 400ms ${tokens.ease}`,
          }}>
            {/* Large number — centered */}
            <div style={{
              fontFamily: tokens.fontDisplay, fontSize: 'min(140px, 22vh)',
              color: tokens.accent, lineHeight: 1,
              letterSpacing: tokens.displayTracking,
              filter: `drop-shadow(0 0 24px ${tokens.accent}55)`,
            }}>{s.n}</div>

            {/* Sense text + prompt — below the number */}
            <div style={{ textAlign: 'center', marginTop: 40 }}>
              <div style={{
                fontFamily: tokens.fontDisplay, fontStyle: 'italic',
                fontSize: 25, color: tokens.accent,
                letterSpacing: tokens.displayTracking,
                lineHeight: 1.3,
              }}>{s.sense}</div>
              <div style={{
                fontFamily: tokens.fontBody, fontSize: 15,
                color: tokens.textMid, marginTop: 14, lineHeight: 1.55,
              }}>{s.prompt}</div>
            </div>
          </div>
        ) : (
          <div style={{
            flex: 1, display: 'flex', flexDirection: 'column',
            alignItems: 'center', justifyContent: 'center',
            padding: '0 28px',
            animation: `gl-fade-up 400ms ${tokens.ease}`,
          }}>
            <div style={{
              fontFamily: tokens.fontDisplay, fontStyle: 'italic',
              fontSize: 30, color: tokens.textHi, letterSpacing: tokens.displayTracking,
              lineHeight: 1.3, textAlign: 'center',
            }}>You're here.</div>
            <div style={{
              fontFamily: tokens.fontBody, fontSize: 14,
              color: tokens.textMid, marginTop: 14, lineHeight: 1.6,
              maxWidth: 260, textAlign: 'center',
            }}>That's the whole point.
              <br />
              You came back to the room.</div>
          </div>
        )}
      </div>

      {/* Footer — back / progress / next */}
      <div style={{
        padding: '10px 20px 28px',
        display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 10,
        flexShrink: 0,
      }}>
        <button className="gl-btn-bare" onClick={() => step > 0 && setStep(step - 1)} disabled={step === 0}
          style={{
            fontFamily: tokens.fontBody, fontSize: 13,
            color: step === 0 ? tokens.textDim : tokens.textLow,
            letterSpacing: '0.05em',
            padding: '6px 4px',
          }}>&#8592; Back</button>
        <div style={{ display: 'flex', gap: 6 }}>
          {steps.map((_, i) => (
            <div key={i} style={{
              width: 16, height: 2,
              background: i <= step ? tokens.accent : tokens.textDim,
              transition: `background 400ms ${tokens.ease}`,
            }} />
          ))}
        </div>
        <button className="gl-btn-bare"
          onClick={() => done ? onClose() : setStep(step + 1)}
          style={{
            fontFamily: tokens.fontBody, fontSize: 13.5,
            color: tokens.accent,
            padding: '8px 16px',
            border: `1px solid ${tokens.accent}`,
            background: tokens.accentGlow,
          }}>{done ? 'Finish' : step === steps.length - 1 ? 'Almost done' : 'Next'}</button>
      </div>
    </div>
  );
}
